export default __webpack_public_path__ + "static/media/green-check-icon.6180b956.svg";